if (typeof window.WishlistManager === 'undefined') {
  window.WishlistManager = {
    storageKey: 'shopify_wishlist',
    
    getWishlist: function() {
      try {
        const wishlist = localStorage.getItem(this.storageKey);
        return wishlist ? JSON.parse(wishlist) : [];
      } catch (e) {
        console.error('Error reading wishlist:', e);
        return [];
      }
    },
    
    saveWishlist: function(wishlist) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
        this.updateWishlistCount();
        this.dispatchWishlistUpdate();
      } catch (e) {
        console.error('Error saving wishlist:', e);
      }
    },
    
 addToWishlist: function(productId, productHandle) {
  const wishlist = this.getWishlist();
  const exists = wishlist.find(item => item.id == productId);
  
  if (!exists) {
    wishlist.push({ id: productId, handle: productHandle });
    this.saveWishlist(wishlist);
    
    // Google Analytics 4 Event
    if (typeof gtag !== 'undefined') {
      gtag('event', 'add_to_wishlist', {
        currency: 'AED',
        items: [{
          item_id: productId,
          item_name: productHandle
        }]
      });
    }
    
    // Google Analytics Universal (legacy - remove if you only use GA4)
    if (typeof ga !== 'undefined') {
      ga('send', 'event', 'Wishlist', 'Add', productHandle);
    }
    
    return true;
  }
  return false;
},

removeFromWishlist: function(productId) {
  let wishlist = this.getWishlist();
  const removedItem = wishlist.find(item => item.id == productId);
  wishlist = wishlist.filter(item => item.id != productId);
  this.saveWishlist(wishlist);
  
  // Google Analytics 4 Event
  if (typeof gtag !== 'undefined' && removedItem) {
    gtag('event', 'remove_from_wishlist', {
      currency: 'AED',
      items: [{
        item_id: productId,
        item_name: removedItem.handle
      }]
    });
  }
  
  // Google Analytics Universal (legacy)
  if (typeof ga !== 'undefined' && removedItem) {
    ga('send', 'event', 'Wishlist', 'Remove', removedItem.handle);
  }
},
    
    isInWishlist: function(productId) {
      return this.getWishlist().some(item => item.id == productId);
    },
    
    toggleWishlist: function(productId, productHandle) {
      if (this.isInWishlist(productId)) {
        this.removeFromWishlist(productId);
        return false;
      } else {
        this.addToWishlist(productId, productHandle);
        return true;
      }
    },
    
    updateWishlistCount: function() {
      const count = this.getWishlist().length;
      document.querySelectorAll('.wishlist-count').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },
    
    dispatchWishlistUpdate: function() {
      window.dispatchEvent(new CustomEvent('wishlistUpdated', {
        detail: { wishlist: this.getWishlist() }
      }));
    }
  };
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    if (window.WishlistManager) {
      window.WishlistManager.updateWishlistCount();
    }
  });
} else {
  if (window.WishlistManager) {
    window.WishlistManager.updateWishlistCount();
  }
}
/* =========================================================================
   Salwar Mahal — product CARD heart (.wishlist-btn) binding via event
   delegation, so it works for every card including AJAX/infinite-scroll
   loaded ones. Product-page heart (.wishlist-btn-product-page) is bound
   separately in wishlist-product-page.liquid — different class, no clash.
   ========================================================================= */
(function () {
  function syncCardHearts() {
    if (typeof window.WishlistManager === 'undefined') return;
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      btn.classList.toggle(
        'is-active',
        window.WishlistManager.isInWishlist(btn.dataset.productId)
      );
    });
  }

  // One delegated handler for all current + future card hearts.
  // CAPTURE phase (3rd arg = true): the card navigates via a click handler on
  // a parent element, which fires during bubbling. Capturing lets us intercept
  // FIRST and stop the event before that parent handler runs.
  function findHeart(e) {
    // 1) normal case: the heart (or its svg/path) is the click target
    var btn = e.target.closest && e.target.closest('.wishlist-btn');
    if (btn) return btn;
    // 2) MOBILE case: the full-card link overlay sits on top and steals the
    //    tap, so the heart isn't e.target. Look at everything stacked under
    //    the tap point and pick the heart if it's there. (Desktop mouse lands
    //    on the heart directly, which is why desktop already worked.)
    if (document.elementsFromPoint && (e.clientX || e.clientY)) {
      var stack = document.elementsFromPoint(e.clientX, e.clientY);
      for (var i = 0; i < stack.length; i++) {
        var c = stack[i].closest && stack[i].closest('.wishlist-btn');
        if (c) return c;
      }
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = findHeart(e);
      if (!btn) return;
      // don't follow the card link / trigger the card's navigation handler
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (typeof window.WishlistManager === 'undefined') return;

      var added = window.WishlistManager.toggleWishlist(
        btn.dataset.productId,
        btn.dataset.productHandle
      );
      btn.classList.toggle('is-active', added);
      btn.classList.remove('sm-pulse');
      // restart the pulse animation
      void btn.offsetWidth;
      btn.classList.add('sm-pulse');
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCardHearts);
  } else {
    syncCardHearts();
  }
  // keep all card hearts in sync when changed anywhere (product page, etc.)
  window.addEventListener('wishlistUpdated', syncCardHearts);
})();
